import "../style/SubscribeForm.scss";

export default function SubscribeForm() {
  return (
    <div className="wrapper">
      <form
        className="card-content"
        action="https://formsubmit.co/evas.agence@gmail.com"
        method="POST"
      >
        <div className="container">
          <div className="image">
            <img src="/logo/email.png" alt="" />
          </div>
          <h1>Subscribe</h1>
          <p>Subscribe to our newsletter and stay updated.</p>
        </div>

        {/* Hidden field for email subject */}
        <input type="hidden" name="_subject" value="New newsletter subscription!" />

        <div className="form-input">
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            required
          />
          <button type="submit" className="subscribe-btn">
            Subscribe
          </button>
        </div>
      </form>
    </div>
  );
}
